import React from 'react';

const ExperienceCard = ({ data, isLast }) => {
  return (
    <div className="timeline-item">
      {/* Small circular logo node anchored over spine */}
      <div className="timeline-node">
        <img
          src={data.companylogo}
          alt={data.role}
          className="timeline-node-img"
        />
      </div>

      {/* Text Content */}
      <div className="timeline-content">
        {/* Accent Date Header (e.g., AUG 2026 – PRESENT) */}
        <div className="timeline-date-accent">
          {data.date}
        </div>

        {/* Role Title */}
        <h3 className="timeline-title">
          {data.role}
        </h3>

        {/* Company Name (if available in data) */}
        {data.company && (
          <div className="timeline-company">
            {data.company}
          </div>
        )}

        {/* Description / Bullet Points */}
        {data.desc && (
          <p className="timeline-desc mb-0">
            {data.desc}
          </p>
        )}

        {!isLast && <div className="timeline-divider" />}
      </div>
    </div>
  );
};

export default ExperienceCard;